// extracted by mini-css-extract-plugin
module.exports = {"aboutPage":"about_aboutPage__38iX4","banner":"about_banner__3vJkT","about":"about_about__1xLiH","title":"about_title__3OA8r","p":"about_p__3RwKx"};